import React from 'react';
import './AmenidadesArtemisa.scss';
import Slider from '../Slider/Slider';
import { SwiperSlide } from "swiper/react";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
const AmenidadesArtemisa = () => {
    return ( 
        <div id="amenidades" className='contenedor_amenidades_artemisa'>
            <div className='amenidades_top_artemisa'>
            <AnimationOnScroll
                        duration={2}
                        animateOnce={true}
                        animateIn='animate__fadeIn'>
                <div className='subtitulo_ame_arte'>
                    <h2>
                        AMENIDADES <br/> EXCLUSIVAS
                    </h2>
                </div>
            </AnimationOnScroll>
                <div className='list_ame_artemisa'>
                <div className='colum_list_artemisa'>
                        <img src="/assets/Artemisa/svg-icon-alberca.svg" alt="Casa club" />
                        <p>Casa club con alberca privada</p>
                    </div>
                    <div className='colum_list_artemisa'>
                        <img src="/assets/Iconos/Amenidades/svg-icon-juegos-infantiles.svg" alt="Juegos infantiles" />
                        <p>Juegos infantiles</p>
                    </div>
                    <div className='colum_list_artemisa'>
                        <img src="/assets/Iconos/Amenidades/svg-icon-lineal.svg" alt="Parque lineal" />
                        <p>8 mil m2 de parque lineal</p>
                    </div>
                    <div className='colum_list_artemisa'>
                        <img src="/assets/Iconos/Amenidades/svg-icon-dogpark.svg" alt="Dog park" />
                        <p>Dog Park</p>
                    </div>
                    <div className='colum_list_artemisa'>
                        <img src="/assets/Iconos/Amenidades/svg-icon-ciclovia.svg" alt="Ciclovia" />
                        <p>Ciclovía y pista para correr periférica de más de 2,500 metros</p>
                    </div>
                    <div className='colum_list_artemisa'>
                        <img src="/assets/Iconos/Amenidades/svg-icon-coworking.svg" alt="Coworking" />
                        <p>Coworking al aire libre</p>
                    </div>
                    <div className='colum_list_artemisa'>
                        <img src="/assets/Iconos/Amenidades/svg-icon-area-verde.svg" alt="Area verde" />
                        <p>1,600 m2 de área verde por privada</p>
                    </div>
                    <div className='colum_list_artemisa'>
                        <img src="/assets/Iconos/Amenidades/svg-icon-padel.svg" alt="Canchas" />
                        <p>Cancha de pádel</p>
                    </div>
                    <div className='colum_list_artemisa'>
                        <img src="/assets/Iconos/Amenidades/svg-icon-picnics.svg" alt="Area de picnics" />
                        <p>Área de picnic</p>
                    </div>
                    <div className='colum_list_artemisa'>
                        <img src="/assets/Iconos/Amenidades/svg-icon-acceso.svg" alt="Doble acceso" />
                        <p>Doble punto de acceso</p>
                    </div>
                    <div className='colum_list_artemisa'>
                        <img src="/assets/Iconos/Amenidades/svg-icon-caseta.svg" alt="Caseta de acceso" />
                        <p>Acceso principal con caseta de control las 24 horas</p>
                    </div>
                </div>
            </div>
            <div id="galeria" className='amenidades_bottom_artemisa'>
            <Slider nav={false} pag={true}>
                    <SwiperSlide>
                        <div className="contenedor__amenidades_carousel__slider_artemisa">
                            <img src="./assets/Artemisa/img-parques-artemisa-velasur.jpg" alt="Velasur" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="contenedor__amenidades_carousel__slider_artemisa">
                            <img src="./assets/Artemisa/img-casa-club-artemisa-velasur.jpg" alt="Velasur" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="contenedor__amenidades_carousel__slider_artemisa">
                            <img src="./assets/Artemisa/img-aereo-artemida-velasur.jpg" alt="Velasur" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="contenedor__amenidades_carousel__slider_artemisa">
                            <img src="./assets/Artemisa/img-andadores-artemisa-velasur.jpg" alt="Velasur" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="contenedor__amenidades_carousel__slider_artemisa">
                            <img src="./assets/Artemisa/img-coworking-artemisa-velasur.jpg" alt="Velasur1" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="contenedor__amenidades_carousel__slider_artemisa">
                            <img src="./assets/Artemisa/img-trotapista-artemisa-velasur.jpg" alt="Velasur" />
                        </div>
                    </SwiperSlide>
            </Slider>
            </div>
        </div>
     );
}
 
export default AmenidadesArtemisa;